module.exports = __webpack_public_path__ + "img/ruihong_swiper_04.b691f5e8.jpg";